import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=5d066278&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=5d066278&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d066278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d066278')) {
      api.createRecord('5d066278', component.options)
    } else {
      api.reload('5d066278', component.options)
    }
    module.hot.accept("./RadarChart.vue?vue&type=template&id=5d066278&scoped=true", function () {
      api.rerender('5d066278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echartZyz/components/RadarChart.vue"
export default component.exports